import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import newLogo from"./solid-step-logo.png";
  
const LOGO_URL = newLogo;

const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Collections", path: "/collections" },
  { label: "Gallery", path: "/gallery" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/90 border-b border-white/5 shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-24">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Golden Touch" className="h-20 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-10" data-testid="desktop-nav">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className={`font-sans text-sm uppercase tracking-[0.15em] transition-colors duration-200 ${
                location.pathname === link.path
                  ? "text-[#D4AF37]"
                  : "text-white/70 hover:text-[#D4AF37]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-6">
          <a
            href="tel:+61413621730"
            data-testid="header-phone"
            className="flex items-center gap-2 text-[#D4AF37] text-sm font-medium"
          >
            <Phone className="w-4 h-4" />
            0413 621 730
          </a>
          <Link
            to="/contact"
            data-testid="header-cta"
            className="bg-[#D4AF37] text-black font-semibold px-6 py-3 text-sm uppercase tracking-wider hover:bg-[#F0C74A] transition-colors"
          >
            Free Quote
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#0a0a0a] border-t border-white/5 animate-fade-in"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className={`text-base font-sans uppercase tracking-wider py-2 ${
                  location.pathname === link.path
                    ? "text-[#D4AF37]"
                    : "text-white/70"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-cta"
              className="bg-[#D4AF37] text-black font-semibold px-6 py-3 text-sm text-center uppercase tracking-wider mt-2"
            >
              Free Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
